import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { SvcAppSettings } from 'projects/lib-shared-common/src/public-api';

@Injectable({
  providedIn: 'root',
})
export class SvcDocumentTitleService {
  private readonly _title = inject(Title);
  private readonly _translocoService = inject(TranslocoService);
  private readonly _appSettings = inject(SvcAppSettings);
  private readonly _destroyRef = inject(DestroyRef);
  private _initialized = false;

  public init(): void {
    if (this._initialized) return;
    this._initialized = true;

    const applicationName = this._appSettings.applicationName;
    if (!applicationName) return;

    this._translocoService
      .selectTranslate(applicationName)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((translatedName: string) => this._title.setTitle(translatedName || applicationName));
  }
}
